module.exports = __webpack_public_path__ + "static/media/MahwahHonda_Logo.5dd15619.jpg";